<template>
  <FormulateInput
    ref="pctInput"
    type="text"
    :name="name"
    :inputmode="inputMode"
    :placeholder="placeholder"
    v-model="formattedValue"
    :validation="validation"
    :validationMessages="validationMessages"
    @change="input"
    @focusout="focusOut"
    @focusin="removePercent"
    @validation="onValidation"
    @blur-context="blurContext"
  />
</template>

<script>
export default {
  data() {
    return {
      formattedValue: null,
    };
  },
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.formattedValue = this.formatNumberToDisplay(this.context.model);
    });
  },
  computed: {
    name() {
      return this.context.attributes.name;
    },
    placeholder() {
      return this.context.attributes.placeholder;
    },
    inputmode() {
      return this.context.attributes.inputmode || 'numeric';
    },
    showPercent() {
      return this.context.attributes.showPercent || true;
    },
    decimals() {
      return this.context.attributes.settings.decimals ?? 2;
    },
    validation() {
      return this.context.attributes.settings.validation ?? '';
    },
    validationMessages() {
      return this.context.attributes.settings.validationMessages ?? {};
    },
  },
  methods: {
    input(e) {
      const value = e?.target?.value;
      this.context.model = value ? this.formatNumberToModel(value) : null;
      this.formattedValue = this.formatNumberToDisplay(value);

      this.$emit('input', this.context.model ? this.context.model : null);
    },
    onValidation(e) {
      this.$emit('validation', e);
    },
    blurContext(e) {
      this.formattedValue = this.formatNumberToDisplay(this.context.model);
      this.$emit('blur-context', e);
    },
    focusOut() {
      this.context.model = this.formatNumberToModel(this.formattedValue);
    },
    removePercent() {
      this.formattedValue = this.formattedValue?.replaceAll(' %', '') ?? null;
    },
    formatNumberToModel(number) {
      var value = number?.toString().replace(',', '.').replace(/[^\d\.]/g, '');
      if (this.hasDecimals(value)) {
        value = this.roundDecimals(value);
      }

      return !!value ? parseFloat(value) : null;
    },
    formatNumberToDisplay(number) {
      if (!number) {
        return null;
      }

      let showedData = number.toString().replace('.', ',').replace(/[^\d\,]/g, '');
      if (this.showPercent) {
        showedData += ' %';
      }
      return showedData;

    },
    hasDecimals(number) {
      return number?.match(/\d+\.\d+/g);
    },
    roundDecimals(value) {
      let decimals = value.split('.');
      return decimals.shift() + '.' + this.roundNumber(decimals[0]);
    },
    roundNumber(number) {
      if (number.length > this.decimals) {
        return number.substring(0, this.decimals);
      }
      return number;
    },
  },
};
</script>
